import { ApplicationConfig } from '@angular/core';
import { MenuService } from 'app';
import { createAppConfig } from 'credo';
import { Logo } from 'shared';
import { routes } from './app.routes';
import { logo } from './assets/icons/logo';
import { environment } from './environments/environment';
import { Fac3lessMenuService } from './services/menu.service';
import { PLATINUM_PRODUCT_CODE } from './services/funnel-intent';

export const appConfig: ApplicationConfig = createAppConfig({
  routes,
  providers: [
    { provide: MenuService, useClass: Fac3lessMenuService },
  ],
  translationScope: 'fac3less',
  // Cookie banner + preference center (Tracking Engine V2, docs/tracking/EVENT_CONTRACT_V2.md).
  // pageId: tracking page of the app outside its checkout; policyKey: document the banner links to.
  consent: { enabled: true, pageId: 'f3-app', policyKey: 'privacy_policy' },
  // Tracking Engine V1 checkout steps of the shared order wizard (docs/tracking/EVENT_CONTRACT_V1.md §3):
  // the Platinum purchase continues there after the direct checkout's account step.
  tracking: { checkout: { pageId: 'f3-checkout', plans: { [PLATINUM_PRODUCT_CODE]: 'platinum' } } },
  environment,
  theme: {
    mode: 'dark',
    colors: {
      primary:   "#00E5FF",
      secondary: "#050505",
      success:   "#00FF9F",
      info:      "#39f",
      warning:   "#f9b115",
      danger:    "#e55353",
      light:     "#ffffff",
      dark:      "#1B1B1B"
    }
  },
  logo: {
      type: 'icon',
      value: logo,
      name: 'logo',
      cssClass: 'logo'
  } as Logo
});